export default {"src":"/_next/static/media/target-tab-ac.8f050faa.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};